import React from "react";
import FooterTableCell from "./FooterTableCell";
import FooterTableRow from "./FooterTableRow";

const TotalRow = ({ totalQtyText, totalPrice }) => (
  <FooterTableRow
    style={{
      background: "#ffffff",
      borderTop: "1px solid #e7efeb"
    }}
  >
    <FooterTableCell
      numeric
      style={{
        paddingTop: 14,
        paddingBottom: 10,
        color: "#6b7d76",
        fontSize: 11,
        fontWeight: 700
      }}
    >
      Total Items
    </FooterTableCell>

    <FooterTableCell
      numeric
      style={{
        paddingTop: 14,
        paddingBottom: 10,
        color: "#19352d",
        fontSize: 13,
        fontWeight: 800
      }}
    >
      {totalQtyText}
    </FooterTableCell>

    <FooterTableCell numeric />

    <FooterTableCell
      style={{
        paddingLeft: "15px",
        paddingTop: 14,
        paddingBottom: 10,
        color: "#35564c",
        fontSize: 12,
        fontWeight: 700
      }}
    >
      Total
    </FooterTableCell>

    <FooterTableCell
      numeric
      style={{
        paddingTop: 14,
        paddingBottom: 10,
        color: "#16845b",
        fontSize: 15,
        fontWeight: 800
      }}
    >
      {"\u20A6"}{Number(totalPrice || 0).toLocaleString()}
    </FooterTableCell>
  </FooterTableRow>
);

export default TotalRow;
